import { render, staticRenderFns } from "./TableDirigentes.vue?vue&type=template&id=372b5c9d"
import script from "./TableDirigentes.vue?vue&type=script&lang=js"
export * from "./TableDirigentes.vue?vue&type=script&lang=js"
import style0 from "./TableDirigentes.vue?vue&type=style&index=0&id=372b5c9d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports